// MARK://dhk8/pos/features/billing/status-badge
// CFDI invoice status pill. Tone by status; no shadows, opacity-only emphasis.

import type { InvoiceStatus } from '../../lib/clients/invoices.js'

const LABELS: Record<InvoiceStatus, string> = {
  DRAFT: 'Borrador',
  PENDING_STAMPING: 'Pendiente',
  STAMPED: 'Timbrada',
  CANCELLED: 'Cancelada',
  STAMPING_FAILED: 'Falló timbrado',
}

function tone(s: InvoiceStatus): 'ok' | 'warn' | 'danger' | 'neutral' {
  if (s === 'STAMPED') return 'ok'
  if (s === 'PENDING_STAMPING') return 'warn'
  if (s === 'CANCELLED' || s === 'STAMPING_FAILED') return 'danger'
  return 'neutral'
}

export function StatusBadge({ status }: { status: InvoiceStatus }) {
  return <span className={`dhk8-bil__badge dhk8-bil__badge--${tone(status)}`}>{LABELS[status]}</span>
}
